import { MouseEvent } from "react";
import { usePodcastProvider, ModalType, PodcastConfig } from "components/podcast/PodcastProvider";
import { getPodcastThemeToken } from "services/utils/getPodcastThemeToken";
//ui
import { IconButton } from "@chakra-ui/react";
import { ShareIcon } from "components/icons";
import PodcastColorTypes from "types/podcastColorTypes";

interface ModalButtonsInterface {
  onOpen: () => void;
  podcastDetails?: PodcastConfig;
}

export function ShareButton({ onOpen, podcastDetails }: ModalButtonsInterface) {
  const { setModalType, setModalPodcast } = usePodcastProvider();

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setModalType(ModalType.Share);
    if (podcastDetails) {
      setModalPodcast(podcastDetails);
    }
    onOpen();
  };
  return (
    <IconButton
      onClick={e => {
        handleClick(e);
      }}
      icon={<ShareIcon width="32px" height="32px" />}
      aria-label="share-podcast"
      borderRadius={{ base: "48px", md: "24px" }}
      _hover={{ bg: "transparent" }}
      color={getPodcastThemeToken(PodcastColorTypes.Icons)}
      bgColor={getPodcastThemeToken(PodcastColorTypes.IconsBackground)}
    />
  );
}
